// NY Barbershop Data

export const barbershopInfo = {
  name: "NY Barbershop",
  owner: "יאיר נחמן",
  tagline: "תספורות בהתאמה אישית לכל ראש",
  description: "ב-NY Barbershop אנחנו מאמינים שכל לקוח ראוי ליחס אישי ותספורת שמותאמת בדיוק לו. אני, יאיר נחמן, בונה תספורות באופן אישי לכל ראש ולכל בקשה. היחס האישי והמקצועיות שלי מבטיחים שתצא עם התוצאה הרצויה - תמיד.",
  phone: "058-7950317",
  address: "רחוב חנקין 5, רעננה",
  addressEn: "Hankin Street 5, Raanana",
  googleMapsUrl: "https://www.google.com/maps/search/Hankin+Street+5+Raanana",
  hours: "11:00-18:30",
  hoursNote: "תור בהזמנה מראש",
  instagram: "Ny_studio44",
  instagramUrl: "https://instagram.com/Ny_studio44/",
  bookingUrl: "https://cali-b5f0e.web.app/#/1Ndmvr24d3bs"
};

export const services = [
  {
    id: 1,
    name: "תספורת",
    price: 80,
    priceLabel: "החל מ-₪80",
    description: "תספורת מקצועית בהתאמה אישית"
  },
  {
    id: 2,
    name: "תספורת + סידור זקן",
    price: 100,
    priceLabel: "₪100",
    description: "תספורת מלאה עם עיצוב וסידור זקן מקצועי"
  },
  {
    id: 3,
    name: "תספורת מייקאובר",
    price: 100,
    priceLabel: "₪100",
    description: "מתאים למי שלא הסתפר כמה חודשים - שינוי מלא"
  },
  {
    id: 4,
    name: "שירות לשיער ארוך",
    price: 120,
    priceLabel: "₪120",
    description: "שירות מקצועי לשיער ממש ארוך עם מספריים"
  }
];

export const barbers = [
  {
    id: 1,
    name: "נחמן",
    fullName: "יאיר נחמן",
    role: "ספר ראשי ובעלים",
    description: "בעל ניסיון רב ומומחיות בבניית תספורות בהתאמה אישית. כל לקוח מקבל יחס אישי ותוצאה מדויקת.",
    services: [
      { name: "תספורת", price: 100 },
      { name: "תספורת + סידור זקן", price: 120 },
      { name: "תספורת מייקאובר", price: 120 },
      { name: "שירות לשיער ארוך", price: 120 }
    ]
  },
  {
    id: 2,
    name: "ערן",
    fullName: "ערן",
    role: "ספר מקצועי",
    description: "ספר מוכשר עם גישה מקצועית ויחס אישי לכל לקוח. מתמחה בתספורות מודרניות ומדויקות.",
    services: [
      { name: "תספורת", price: 80 },
      { name: "תספורת + סידור זקן", price: 100 },
      { name: "תספורת מייקאובר", price: 100 },
      { name: "שירות לשיער ארוך", price: 120 }
    ]
  }
];

export const galleryImages = [
  // פייד (Fade)
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_b10b54f9-c7f8-4303-8d18-443e57e7d225/artifacts/zgsu02qb_IMG_7255.png",
    alt: "קרופ טקסטורה עם סקין פייד",
    category: "פייד"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_b10b54f9-c7f8-4303-8d18-443e57e7d225/artifacts/ff6igz57_IMG_7251.png",
    alt: "תלתלים עם פייד - סטייל מודרני",
    category: "פייד"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_b10b54f9-c7f8-4303-8d18-443e57e7d225/artifacts/7t0e26d1_image.png",
    alt: "פייד טקסטורה - מבט מאחור",
    category: "פייד"
  },
  // קלאסי (Classic)
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_b10b54f9-c7f8-4303-8d18-443e57e7d225/artifacts/q32wtpuv_IMG_7253.png",
    alt: "סליקבק קלאסי עם זקן מסודר",
    category: "קלאסי"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_b10b54f9-c7f8-4303-8d18-443e57e7d225/artifacts/0e50fmq3_image.png",
    alt: "שיער חלק עם שכבות - מראה קלאסי",
    category: "קלאסי"
  },
  // טקסטורה (Textured)
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_b10b54f9-c7f8-4303-8d18-443e57e7d225/artifacts/ufzdk2e1_IMG_7252.png",
    alt: "שכבות טקסטורה עם נפח - מראה טבעי",
    category: "טקסטורה"
  },
  {
    id: 7,
    src: "https://customer-assets.emergentagent.com/job_b10b54f9-c7f8-4303-8d18-443e57e7d225/artifacts/tbmv80s9_image.png",
    alt: "תלתלים טבעיים עם מאלט - סטייל חופשי",
    category: "טקסטורה"
  },
  // שיער ארוך (Long Hair)
  {
    id: 8,
    src: "https://customer-assets.emergentagent.com/job_b10b54f9-c7f8-4303-8d18-443e57e7d225/artifacts/ww7aq5y1_IMG_7257.png",
    alt: "שיער ארוך מעוצב - שכבות ונפח",
    category: "שיער ארוך"
  },
  // המספרה (Barbershop)
  {
    id: 9,
    src: "https://customer-assets.emergentagent.com/job_9e6d1a7c-82a4-4b2d-8ddf-ccb16822431b/artifacts/wks5zhi4_image.png",
    alt: "חזית המספרה NY Barbershop",
    category: "המספרה"
  },
  {
    id: 10,
    src: "https://customer-assets.emergentagent.com/job_b10b54f9-c7f8-4303-8d18-443e57e7d225/artifacts/6lo4p8n9_image.png",
    alt: "המספרה בלילה - עמוד ספר מואר",
    category: "המספרה"
  },
  {
    id: 11,
    src: "https://customer-assets.emergentagent.com/job_9e6d1a7c-82a4-4b2d-8ddf-ccb16822431b/artifacts/fy45qg93_10128241_1734537700148_0.png",
    alt: "עמדות עבודה במספרה",
    category: "המספרה"
  }
];

export const features = [
  {
    id: 1,
    title: "יחס אישי",
    description: "כל לקוח מקבל תשומת לב מלאה והתאמה אישית"
  },
  {
    id: 2,
    title: "מקצועיות",
    description: "ניסיון רב ומיומנות בכל סוגי התספורות"
  },
  {
    id: 3,
    title: "תוצאה מובטחת",
    description: "יוצאים מרוצים - תמיד"
  }
];
